import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconDotGrid1x3Horizontal: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="dot-grid-1x3-horizontal, menu, drag, grab"><path d="M2.75 11H4.75V13H2.75V11Z" fill="currentColor"/><path d="M13 11H11V13H13V11Z" fill="currentColor"/><path d="M19.25 11H21.25V13H19.25V11Z" fill="currentColor"/><path d="M2.75 11H4.75V13H2.75V11Z" stroke="currentColor" strokeWidth="1.5"/><path d="M13 11H11V13H13V11Z" stroke="currentColor" strokeWidth="1.5"/><path d="M19.25 11H21.25V13H19.25V11Z" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconDotGrid1x3Horizontal;
